module.exports = __webpack_public_path__ + "media/small/user-b03f1803.jpg";